import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StatCard } from '../components/StatCard';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Award, Download, CheckCircle, Star, Target, ShieldAlert, TrendingUp, Clock } from 'lucide-react';
export function Qualite() {
  return <div className="flex flex-col w-full" data-id="element-2061" data-mp="1nq91rvxcbs5z">
      <PageHeader title="Qualité et Transparence" subtitle="Zillenium Alternance s'engage dans une démarche d'amélioration continue pour garantir l'excellence de ses formations." data-id="element-2062" data-mp="1srg5njwd477d" />

      {/* Intro */}
      <section className="py-16 md:py-24 bg-white" data-id="element-2063" data-mp="1irfmpz2ent3p">
        <div className="container max-w-4xl mx-auto text-center" data-id="element-2064" data-mp="2f0m0r0tkakn">
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed font-medium" data-id="element-2065" data-mp="2gv66349nyno">
            Notre démarche qualité place l'apprenant et l'entreprise au cœur de
            nos préoccupations. Nous mesurons régulièrement nos performances
            afin d'adapter nos méthodes pédagogiques et de répondre aux
            exigences du référentiel national qualité.
          </p>
        </div>
      </section>

      {/* Certificats Qualiopi */}
      <section className="py-24 bg-muted relative overflow-hidden" data-id="element-2066" data-mp="1z1gilohhi6vd">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2067" data-mp="2dzir8d3dhijh" />
        <div className="container max-w-5xl mx-auto relative z-10" data-id="element-2068" data-mp="28zw8jo4rza3a">
          <SectionHeading title="Nos certifications Qualiopi" centered data-id="element-2069" data-mp="2msm1kciq1f9w" />
          <div className="grid md:grid-cols-2 gap-10 mt-16" data-id="element-2070" data-mp="2iqh75bkg8em7">
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-2071" data-mp="2ir0puuhxb71a">
              <div className="h-2 w-full bg-primary" data-id="element-2072" data-mp="2wo5tyoy2tvtw" />
              <CardHeader className="pt-8 pb-4" data-id="element-2073" data-mp="2rs8cgfb2ujfj">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-2074" data-mp="2rpccymjkzmoz">
                  <Award className="w-8 h-8 text-primary animate-soft-pulse" data-id="element-2075" data-mp="1tg5uic0uxoi5" />
                </div>
                <CardTitle className="text-2xl font-extrabold font-heading text-primary-dark" data-id="element-2076" data-mp="1ydnu3bszirdh">
                  Formation par apprentissage
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-2077" data-mp="283h262tx4ocz">
                <p className="text-lg text-muted-foreground mb-8" data-id="element-2078" data-mp="286d21wpbtn42">
                  Certifié par CAPCERT. Valable jusqu'au 30/10/2027.
                </p>
                <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-2079" data-mp="2h4oxcc15192u">
                  <a href="https://cdn.magicpatterns.com/uploads/uxuWAaU2vHtjX7ZhfSq9Aw/Capture_d’ecran_2026-06-21_a_19.37.57.png" target="_blank" rel="noopener noreferrer" data-id="element-2080" data-mp="ms7jtw63pnbe">
                    <Download className="w-5 h-5 mr-2" data-id="element-2081" data-mp="ffrjpqps40k4" />
                    Télécharger le certificat
                  </a>
                </Button>
              </CardContent>
            </Card>

            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-2082" data-mp="5hlilbbsqygb">
              <div className="h-2 w-full bg-brand-orange" data-id="element-2083" data-mp="135vm5ur8du9j" />
              <CardHeader className="pt-8 pb-4" data-id="element-2084" data-mp="1339ezw895gru">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-2085" data-mp="y5zglr2vxurv">
                  <Award className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-2086" data-mp="t90qrkq989zh" />
                </div>
                <CardTitle className="text-2xl font-extrabold font-heading text-primary-dark" data-id="element-2087" data-mp="3dxeypp27u7wu">
                  Actions de formation
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-2088" data-mp="39y664niwwg2v">
                <p className="text-lg text-muted-foreground mb-8" data-id="element-2089" data-mp="11mlkz9szwvvg">
                  Certifié par CAPCERT. Valable jusqu'au 01/09/2027.
                </p>
                <Button variant="outline" className="w-full border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-2090" data-mp="16f4zc8zibv1b">
                  <a href="https://cdn.magicpatterns.com/uploads/2eVnp5Bk4nD8NeVbW5n73A/Capture_d’ecran_2026-06-21_a_19.38.12.png" target="_blank" rel="noopener noreferrer" data-id="element-2091" data-mp="wlxsejp4c6z4">
                    <Download className="w-5 h-5 mr-2" data-id="element-2092" data-mp="1bbvemu3hmmlo" />
                    Télécharger le certificat
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Indicateurs de résultats */}
      <section id="indicateurs" className="py-24 bg-white relative overflow-hidden" data-id="element-2093" data-mp="3zuxogz7wb40">
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2094" data-mp="3skf78zrpv2qf" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-2095" data-mp="3nlvk4w1dzkwh">
          <SectionHeading title="Nos indicateurs de résultats réels" centered data-id="element-2096" data-mp="6cys4efz06nf" />

          <div className="space-y-20 mt-16" data-id="element-2097" data-mp="1edt2icgft0k">
            <div data-id="element-2098" data-mp="1fouibifgooi">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2099" data-mp="1d2nqe3d2d7c">
                TP Conseiller de Vente{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2100" data-mp="34wox4wtk874v">
                  (Session 2024/2025)
                </span>
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2101" data-mp="3ettm14esigpd">
                <StatCard value="100%" label="Réussite" icon={<CheckCircle className="w-8 h-8" data-id="element-2103" data-mp="2r24qlf6o9c47" />} data-id="element-2102" data-mp="3erqolzbb5lam" />
                <StatCard value="97%" label="Satisfaction" icon={<Star className="w-8 h-8" data-id="element-2105" data-mp="3bss3f41dz9if" />} data-id="element-2104" data-mp="2m4moa7n5tv56" />
                <StatCard value="60%" label="Présentation examen" icon={<Target className="w-8 h-8" data-id="element-2107" data-mp="3klbxdr6qgpwx" />} data-id="element-2106" data-mp="3fudf4m26phr1" />
                <StatCard value="40%" label="Rupture" icon={<ShieldAlert className="w-8 h-8" data-id="element-2109" data-mp="2sufi6jx7a96h" />} data-id="element-2108" data-mp="3pkoqgto76t7y" />
              </div>
              <p className="text-center text-lg text-muted-foreground mt-8 font-medium" data-id="element-2110" data-mp="2swsa9pwo9zx9">
                Suites de parcours : 60% poursuite d'études / 40% emploi
              </p>
            </div>

            <div className="max-w-4xl mx-auto" data-id="element-2111" data-mp="31xgnwji5ly9m">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2112" data-mp="36v8d35rez6a4">
                BTS NDRC{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2113" data-mp="h4mucf6czyc0">
                  (Enquête mai 2026)
                </span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2114" data-mp="26ma515to7jmm">
                <StatCard value="94%" label="Satisfaction globale" icon={<TrendingUp className="w-8 h-8" data-id="element-2116" data-mp="1wvp61ha34d36" />} data-id="element-2115" data-mp="21n77s7jxmhp7" />
                <Card className="bg-muted border-none flex items-center justify-center p-8 text-center shadow-inner" data-id="element-2117" data-mp="1wtuj5xf96awg">
                  <span className="text-lg text-muted-foreground font-medium" data-id="element-2118" data-mp="1nv962hsjvo32">
                    Résultats aux examens attendus en 2027
                  </span>
                </Card>
              </div>
            </div>

            <div className="max-w-4xl mx-auto" data-id="element-2119" data-mp="1dwjnemstxzlr">
              <h3 className="text-3xl font-extrabold font-heading mb-10 text-center text-primary-dark" data-id="element-2120" data-mp="1dzfkya0rmm9o">
                TP Négociateur Technico-Commercial{' '}
                <span className="text-primary font-medium text-2xl block mt-2" data-id="element-2121" data-mp="38ab4g7dhnlr8">
                  (Session 2026/2027)
                </span>
              </h3>
              <Card className="border-none shadow-lg bg-white overflow-hidden" data-id="element-2122" data-mp="2c6x5cpx7j34z">
                <div className="h-2 w-full bg-brand-orange" data-id="element-2123" data-mp="2c904q0k928md" />
                <CardContent className="p-8 md:p-12 text-center" data-id="element-2124" data-mp="2h4oytodi2xba">
                  <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-2125" data-mp="23f514wys0q8u">
                    <Clock className="w-8 h-8 text-brand-orange animate-soft-pulse" data-id="element-2126" data-mp="27ff5k56x78ll" />
                  </div>
                  <span className="inline-block bg-brand-orange/10 text-brand-orange text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-2127" data-mp="1tfe3imex5v4j">
                    Formation en cours
                  </span>
                  <h4 className="text-2xl font-extrabold font-heading text-primary-dark mb-4" data-id="element-2128" data-mp="1khkbvos3npnp">
                    Indicateurs en cours de constitution
                  </h4>
                  <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto" data-id="element-2129" data-mp="3eutldgknbb5y">
                    La session démarre en <strong data-id="element-2130" data-mp="3iukmoe7st9oq">septembre 2026</strong>. Aucune
                    promotion n'étant encore arrivée à son terme, les taux de
                    réussite, de satisfaction et d'insertion seront publiés à
                    l'issue du premier jury, conformément à notre engagement de
                    transparence.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>;
}